import { Icons } from "assets/icons";
import DisplayPrice from "components/common/DisplayPrice";
import React from "react";

const StatCard = ({ title, value, icon, type, month }) => {
  const IconSrc = Icons[icon];

  return (
    <div className="stat_card">
      <div className="stat_card__icon">
        {IconSrc && <img src={IconSrc} alt={title} width={40} height={40} />}
      </div>
      <div className="stat_card__left">
        <div className="d-flex justify-content-between">
          <p className="stat_card__title">{title}</p>
          {/* <span className="stat_card_small_text">{month}</span> */}
        </div>

        {type === "status" ? (
          <div className="stat_card__status">
            <div className="status_inner">
              <span className="status_dot active" />
              <span>{value.active}</span>
            </div>

            <div className="status_inner">
              <span className="status_dot inactive" />
              <span>{value.inactive}</span>
            </div>
          </div>
        ) : type === "price" ? (
          <DisplayPrice value={value} width="15" height="16" color="#0F0F0F" />
        ) : (
          <div className="d-flex align-items-end gap-2">
            <h3 className="stat_card__value">{value}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
